import moment from "moment";
import React from "react";
import DataTable from "src/components/Table";
import { StyledTableCell } from "src/components/Table/TableCell";
import TableRow from "src/components/Table/TableRow";
import { colors } from "src/styles";
import { ID } from "src/types";
import styled from "styled-components";

export interface AttendanceLogTableRow {
  id: ID;
  teamMember: string;
  date: string;
  start: string;
  end: string;
  filterDate?: string;
}

export interface AttendanceLogsTableProps {
  isLoading: boolean;
  headers: string[];
  data: AttendanceLogTableRow[];
  onRowClick: (id: ID) => void;
}

export const AttendanceLogsTable = ({ isLoading, headers, data, onRowClick }: AttendanceLogsTableProps) => {
  return (
    <DataTable isLoading={isLoading} headers={headers}>
      <>
        {data?.map(({ id, teamMember, date, start, end }: AttendanceLogTableRow) => {
          return (
            <TableRow onClick={() => onRowClick(id)} $clickable key={id}>
              <StyledCell>{teamMember}</StyledCell>
              <StyledCell>{date}</StyledCell>
              <StyledCell>{start === "—" ? "—" : moment(start, "hh:mm A").format("hh:mm A")}</StyledCell>
              <StyledCell>{end === "—" ? "—" : moment(end, "hh:mm A").format("hh:mm A")}</StyledCell>
            </TableRow>
          );
        })}
      </>
    </DataTable>
  );
};

interface StyledCellProps {
  $endTime?: string;
}

const StyledCell = styled(StyledTableCell)<StyledCellProps>`
  height: 50px;
  box-sizing: content-box;
  padding: 10px;
  color: ${({ $endTime }: StyledCellProps) => ($endTime === "" ? colors.green.light : "")};
`;
